import { useEffect, useState } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { candidatureStatus, fluxCandidature } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getEntrepriseInfoRoleBased, getNomPrenomClearFromPersoData, searchLabelInEnumByValue } from '../../../Utils/utils';
import { getPaymentSimulationResults } from '../../../Utils/utilsCraX';

//export const //cellStyle={
//    borderRight:'1px solid #C3C9F1'
//};

const Candidatures = () => {
    const { addEuro4Decimal } = useNumberFormatting();
    const { i18n } = useTranslation();
    const role=useRole();
    const ExpertCandidaturesColumns = [
        {
            field: 'aoId',
            title: i18n.t('Réf. AO'),
            //cellStyle://cellStyle

        },
        {
            field: 'createdAt',
            title: i18n.t('Date de candidature'),
            //cellStyle://cellStyle
        },
        {
            field: 'nomExpert',
            title: i18n.t('Nom d\'expert'),
            hidden:(role=='esn'?false:true),
            //cellStyle://cellStyle
        },
        {
            field: 'source',
            title: i18n.t('Source'),
            //cellStyle://cellStyle
        },
        {
            field: 'nomClient',
            title: i18n.t('Nom du Client'),
            // render: rowData =>
            // {getEntrepriseInfoRoleBased({
            //     info2Display:ao?.entrepriseData?.entrepriseName,
            //     isVisible2Expert: !(ao?.entrepriseData?.nomEntrepriseConfidentiel),
            //     role: role
            // })=='Non précisé' ? 'Confidentiel' : ao?.entrepriseData?.entrepriseName;}
            //cellStyle://cellStyle
        },
        {
            field: 'intitulePoste',
            title: i18n.t('Intitulé de l\'AO'),
            //cellStyle://cellStyle
        },
        {
            field: 'status',
            title: i18n.t('Statut Candidature'),
            render: rowData =>
                i18n.t(searchLabelInEnumByValue(candidatureStatus, rowData?.status))
            //cellStyle://cellStyle
            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'dateDebutMission',
            title: i18n.t('Date début Mission'),
            // cellStyle
        },
        {
            field: 'dateFinMission',
            title: i18n.t('Date fin Mission'),
            // cellStyle
        },
        {
            field: 'localisation',
            title: i18n.t('Localisation'),
            //cellStyle://cellStyle
        },
        {
            field: 'dureeMission',
            title: i18n.t('Durée de la mission'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.dureeMission,'j');
            }
            //cellStyle://cellStyle
        },
        {
            field: 'dureeBDC',
            title: i18n.t('Durée du BDC'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.dureeBDC,'mois');
            }
            //cellStyle://cellStyle
        },
        {
            field: 'budgetMax',
            title: i18n.t('Budget /j '),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.budgetMax);
            }
            //cellStyle://cellStyle
        },
        {
            field: 'tj',
            title: i18n.t('TJ souhaité'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.tj);
            }
            //cellStyle://cellStyle
        },
    ];
    const [candidatures, setCandidatures] = useState();
    const [candidatures4Table, setCandidatures4Table] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const { setBackdropOpen }=useUtilities();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [filtreCandidat, setFiltreCandidat] = useState(searchParams.get('filtreCandidat') === 'true');
    const [filtreCandidatInterview, setFiltreCandidatInterview] = useState(searchParams.get('filtreCandidatInterview') === 'true');
    const [candidatRetenu, setCandidatRetenu] = useState(searchParams.get('candidatRetenu') === 'true');
    const [url, setUrl] = useState('');

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtrecandidat') && !url.toLowerCase().includes('candidatretenu') && !url.toLowerCase().includes('filtrecandidatinterview') ){
            setFiltreCandidat(false);
            setCandidatRetenu(false);
            setFiltreCandidatInterview(false);
        }
    }, [url]);

    useEffect(() => {
        getMyCandidatures();
    }, [filtreCandidat,filtreCandidatInterview,candidatRetenu]);

    useEffect(() => {
        getMyCandidatures();
    }, []);

    const getMyCandidatures = async () => {
        try {
            setBackdropOpen(true);
            const response = await axiosPrivate.get('/candidature/getMyCandidatures', {
            });
            console.log(response.data);
            setCandidatures(response.data?.candidatures);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error);
            setBackdropOpen(false);
        }
    };

    const mapCandidature = (candidature) => {
        return {
            'id': candidature?._id,
            'aoId': candidature?.aoId?.aoId,
            '_aoId': candidature?.aoId?._id,
            'createdAt': formatDateJJMMYYYY(candidature?.createdAt),
            'nomExpert':role=='esn'? getNomPrenomClearFromPersoData(candidature?.expertId?.persoData):'',
            'nomClient': getEntrepriseInfoRoleBased({
                info2Display:candidature?.aoId?.entrepriseData?.entrepriseName,
                isVisible2Expert: !(candidature?.aoId?.entrepriseData?.nomEntrepriseConfidentiel),
                role: 'expert'
            })=='Non précisé' ? 'Confidentiel' : candidature?.aoId?.entrepriseData?.entrepriseName,
            'intitulePoste': candidature?.aoId?.intitulePoste,
            'status': candidature?.status,
            'source':i18n.t(searchLabelInEnumByValue(fluxCandidature,candidature?.flux)),
            'dateDebutMission': formatDateJJMMYYYY(candidature?.aoId?.dateDebutMission),
            'dateFinMission': formatDateJJMMYYYY(candidature?.aoId?.dateFinMission),
            'localisation': candidature?.aoId?.localisation,
            'dureeMission': candidature?.aoId?.dureeMission,
            'dureeBDC': candidature?.aoId?.dureeBDC,
            'budgetMax': candidature?.aoId?.visibilityTjMax ? (getPaymentSimulationResults({ tjClient: candidature?.aoId?.tjMax, commissionHTH: 0.2 })?.tj ?? 'Non précisé') : 'Non précisé',
            'tj': candidature?.tj,
        };
    };
    useEffect(() => {
        if (candidatures) {
            let Array1 = [];
            candidatures.reverse().forEach((candidature) => {
                if ((filtreCandidat && candidature?.status === 'analyzed') ||
                    (candidatRetenu && (candidature?.status === 'retained' || candidature?.status === 'converted')) ||
                    (filtreCandidatInterview && candidature?.status === 'interview') ||
                    (!filtreCandidat && !candidatRetenu && !filtreCandidatInterview)) {
                    Array1.push(mapCandidature(candidature));
                }
            });

            setCandidatures4Table(Array1);
            console.log(Array1, candidatures4Table);
        }
    }, [candidatures]);

    return (
        <>
            <div className='frame5Profile'>
                {role=='esn'? i18n.t('Appels d\'offres HTH'):i18n.t('Appels d\'offres')} &gt;
                <span style={{ color: 'rgba(39, 45, 60, 1)' }}>
                    {i18n.t('Mes candidatures')}
                </span>
            </div>
            <div className='HomeFrame'>
                <div className='HomeFrameTitle'>
                    <h1 className='TitleHStyle'>{i18n.t('Mes candidatures')}</h1>
                </div>
                <MaterialTableComponent
                    title={i18n.t('Candidatures')}
                    columns={ExpertCandidaturesColumns}
                    data={candidatures4Table}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                        navigate(`/${role}/candidatures/${rowData?._aoId}`);
                    }}
                    selectedRow={selectedRow}
                />
                {/*<div className='Frame4AllAOs'>
                    <ThemeProvider theme={defaultMaterialTheme}>
                        <MaterialTable
                            icons={tableIcons}
                            title="Candidatures"
                            columns={ExpertCandidaturesColumns}
                            data={candidatures4Table}
                            options={materialTableOptions}
                            onRowClick={(event, rowData) => {
                                navigate(`/expert/ao/${rowData?._aoId}`,
                                );
                            }}
                        />
                    </ThemeProvider>
                </div>*/}
            </div>
        </>
    );
};

export default Candidatures;
